import { render, staticRenderFns } from "./DetalhesPoliticaDesconto.vue?vue&type=template&id=1e58a045&scoped=true&"
import script from "./DetalhesPoliticaDesconto.vue?vue&type=script&lang=js&"
export * from "./DetalhesPoliticaDesconto.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesPoliticaDesconto.vue?vue&type=style&index=0&id=1e58a045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e58a045",
  null
  
)

export default component.exports